module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_HKPC.e0d67364.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_HKPC.png
// module id = 59
// module chunks = 0